import { render, staticRenderFns } from "./OfferCompositionModal.vue?vue&type=template&id=04485ceb"
import script from "./OfferCompositionModal.vue?vue&type=script&lang=js"
export * from "./OfferCompositionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports